import type { SceneContext } from '../_shared/types'
import type { ChatData } from './types'
import { chatReveal } from './tick'

export default function ChatStory({ data, time }: SceneContext) {
  const d = data as unknown as ChatData
  const { revealCount } = chatReveal(data, time)
  const count = revealCount
  const messages = d.messages || []
  const bubbles = []
  for (let i = 0; i < Math.min(count, messages.length); i++) {
    const m = messages[i]
    const isLeft = m.sender === 0
    const name = (d.participants?.[m.sender] || '').split(' ')[0]
    bubbles.push(
      <div className={`pv-chat-msg ${isLeft ? 'pv-chat-left' : 'pv-chat-right'}`} key={i}>
        <div className="pv-chat-sender">{name}</div>
        <div className="pv-chat-bubble">{m.text}</div>
        <div className="pv-chat-time">{m.time}</div>
      </div>,
    )
  }
  // typing indicator
  if (count < messages.length) {
    const m = messages[count]
    const isLeft = m.sender === 0
    const name = (d.participants?.[m.sender] || '').split(' ')[0]
    bubbles.push(
      <div className={`pv-chat-msg ${isLeft ? 'pv-chat-left' : 'pv-chat-right'} pv-chat-typing`} key="typing">
        <div className="pv-chat-sender">{name}</div>
        <div className="pv-chat-bubble">
          <span className="pv-chat-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>,
    )
  }
  return (
    <div className="pv-chat" style={{ background: (data as any).bgColor }}>
      <div className="pv-chat-header">{d.title}</div>
      <div className="pv-chat-messages">
        {bubbles.length ? bubbles : <div className="pv-chat-empty">Messages will appear here</div>}
      </div>
    </div>
  )
}
